<!--
 * @Author: csu chen.su@murata.com
 * @Date: 2022-06-22 15:36:48
 * @LastEditors: csu chen.su@murata.com
 * @LastEditTime: 2023-09-21 18:02:50
 * @FilePath: \frontend\src\components\ChangeLang\index.vue
-->
<template>
  <div>
    <el-dropdown class="avatar-container" trigger="click">
      <div style="color: aliceblue">
        <svg-icon icon-class="lang" style="color: aliceblue; font-size: 25px; padding-top: 5px" />
        <el-icon style="color: aliceblue; font-size: 10px; padding-top: 5px"><CaretBottom /></el-icon>
      </div>
      <template #dropdown>
        <el-dropdown-menu class="user-dropdown">
          <el-dropdown-item @click="changeLang('en')">
            <span style="display: block">{{ $t('navbar.en') }}</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click="changeLang('ja')">
            <span style="display: block">{{ $t('navbar.ja') }}</span>
          </el-dropdown-item>
          <!-- <el-dropdown-item divided @click.native="changeLang('zh')">
          <span style="display:block;">{{ $t('navbar.zh') }}</span>
        </el-dropdown-item> -->
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
import { CaretBottom } from '@element-plus/icons-vue';

export default {
  name: 'ChangeLang',
  components: {
    CaretBottom,
  },
  data() {
    return {};
  },
  methods: {
    changeLang(lang) {
      this.$langSetup(lang);
    },
  },
};
</script>
